import { Tag, TagTooltip } from "@components/library";
import { COLORS, FONTS } from "@constants";
import styled from "styled-components";

interface Props {
  tags?: string[] | null;
  heading: string;
}

const MAX_TAG_DISPLAY_COUNT = 10;

const RequestPageTagsContainer = ({ tags, heading }: Props) => {
  if (!tags?.length) return null;

  return (
    <Container>
      <Heading>{heading}</Heading>
      <Tags>
        {tags.slice(0, MAX_TAG_DISPLAY_COUNT).map((tag) => (
          <Tag key={tag} content={tag} />
        ))}
        {tags.length > MAX_TAG_DISPLAY_COUNT && (
          <TagTooltip
            tags={tags.slice(MAX_TAG_DISPLAY_COUNT).map((tag) => (
              <Tag key={tag} content={tag} />
            ))}
          >
            <Tag content={`${tags.length - MAX_TAG_DISPLAY_COUNT} more`} />
          </TagTooltip>
        )}
      </Tags>
    </Container>
  );
};

export default RequestPageTagsContainer;

const Container = styled.div`
  padding: 24px;
  border: 1px solid ${COLORS.NEUTRAL_250};
  border-radius: 8px;
`;
const Heading = styled.div`
  margin-bottom: 20px;
  ${FONTS.SEMIBOLD_1};
`;
const Tags = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  line-height: 1;
`;
